import { render, staticRenderFns } from "./EventB2B.vue?vue&type=template&id=48d51686&"
import script from "./EventB2B.vue?vue&type=script&lang=js&"
export * from "./EventB2B.vue?vue&type=script&lang=js&"
import style0 from "./EventB2B.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports